import { Component, Output, Input, EventEmitter } from '@angular/core';

import { firstValueFrom } from 'rxjs';
import { LoadingService } from '../../services/loading.service';
import { NotificationService } from '../../services/notification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { VisaApplicationStatusDto } from '../../dtos/visa-application/visa-application.dto';
import { VisaApplicationService } from '../../services/visa-application.service';
import { VisaDocumentUploadDto } from '../../dtos/visa-application/visaDocumentUploadDto';
import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { InvoiceService } from '../../services/invoice.service';
import { VisaNoteUpdateDto } from '../../dtos/visa-application/visaNoteUpdateDto';
import { VisaDiscountRateCreateDto } from '../../dtos/visa-discount-rate/VisaDiscountRateDto';

@Component({
  selector: 'application-detail-panel',
  templateUrl: './application-detail-panel.component.html',
  styleUrls: ['./application-detail-panel.component.scss'],
  providers: [],
})
export class ApplicationDetailComponent {
  @Input() isOpened = false;
  @Input() selectedVisaApplication: any;
  @Input() selectedVehicleInquiry: any;
  @Output() isOpenedChange = new EventEmitter<boolean>();
  @Output() pinnedChange = new EventEmitter<boolean>();
  @Output() invoiceUpdated = new EventEmitter<void>();
  rules = { X: /[02-9]/ };
  pinned = false;
  isLoading = true;
  popupVisible = false;
  documentPopupVisible = false;
  imageTitle = '';
  imageUrl = '';
  visaUploadError: string | null = null;
  visaDeleteMessage: string | null = null;
  mailWarningMessage: string | null = null;
  visaHtmlContent: string | null = null;
  mailStatus: 'success' | 'error' | null = null;
  visaDeleteMessageStatus: 'success' | 'error' | null = null;
  copiedField: string | null = null;
  deliveredMap = new Map<number, boolean>();
  

  constructor(
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private visaApplicationService: VisaApplicationService,
    private sanitizer: DomSanitizer,
    private _http: HttpClient,
    private invoiceService: InvoiceService
  ) {}

  
  openImage(title: string, url: string) {
    this.imageTitle = title;
    this.imageUrl = environment.imageUrl + '/' + url;
    this.popupVisible = true;
  }

  async downloadFile(path: string, filename: string) {
    if (!path) {
      this.notificationService.showError('Dosya bulunamadı');
      return;
    }

    try {
    
      const fullUrl = environment.imageUrl + '/' + path;

      let fileExtension = '';
      const urlParts = path.split('.');
      if (urlParts.length > 1) {
        fileExtension = '.' + urlParts[urlParts.length - 1];
      }
    
      const downloadFileName = `${this.selectedVisaApplication.visaApplicationId}_${this.selectedVisaApplication.customerPassportNumber}_${this.selectedVisaApplication.customerFirstName}_${this.selectedVisaApplication.customerLastName}_${filename}${fileExtension}`;

      const response = await fetch(fullUrl);
      if (!response.ok) {
        this.notificationService.showError(`Dosya bulunamadı veya erişilemiyor. Status: ${response.status}`);
        return;
      }
      const blob = await response.blob();
      if (!blob || blob.size === 0) {
        this.notificationService.showError('Dosya boş veya bulunamadı');
        return;
      }
 
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = downloadFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      this.notificationService.show('Dosya başarıyla indirildi');
    } catch (error) {
      console.error('Dosya indirme hatası:', error);
      this.notificationService.showError('Dosya indirilirken bir hata oluştu. ');
    }
  }
  onClosePanel = () => {
    this.isOpened = false;
    this.pinned = false;
    this.isOpenedChange.emit(this.isOpened);
  };

  async update() {
    this.loadingService.show();
    const backup = { ...this.selectedVisaApplication };

    try {
      const updatedData: VisaNoteUpdateDto = {
        id: this.selectedVisaApplication.id,
        customerId: this.selectedVisaApplication.visaApplicationCustomerId,
        note: this.selectedVisaApplication.note,
        isCargoSended: this.selectedVisaApplication.isCargoSended,
      };
      await firstValueFrom(
        this.visaApplicationService.updateStatusCustomer(updatedData)
      );
      this.notificationService.showLeft('Güncelleme başarıyla kaydedildi');
    } catch {
      this.selectedVisaApplication = backup;
      this.notificationService.showLeft('Güncelleme sırasında bir hata oluştu', { type: 'error' });
    } finally {
      this.loadingService.hide();
    }
  }



  getSanitizedHtmlUrl(path: string): SafeResourceUrl {
    const fullPath = environment.imageUrl + path.replace(/\\/g, '/');
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullPath);
  }

  async onVisaDocUploaded(event: any): Promise<void> {
    const file = event.value[0];

    if (!file) return;

    this.loadingService.show();

    this.visaUploadError = null;

    try {
      const base64 = await this.convertToBase64(file);

      const dto: VisaDocumentUploadDto = {
        customerId: this.selectedVisaApplication.visaApplicationCustomerId,
        visaDocumentName: file.name,
        visaDocumentBase64: base64,
      };

      await firstValueFrom(this.visaApplicationService.uploadVisaDocument(dto));

      this.selectedVisaApplication.visaDocumentUrl = `uploads/Customer/U${this.selectedVisaApplication.customerPassportNumber}/${file.name}`;
    } catch (error: any) {
      const errorMessage = error?.error || 'Vize dökümanı yüklenemedi.';
      this.visaUploadError = errorMessage;

      if (event?.component) {
        event.component.reset();
      }

      setTimeout(() => {
        this.visaUploadError = null;
      }, 3000);
    } finally {
      this.loadingService.hide();
    }
  }

  private convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  async deleteVisaDocument() {
    this.visaDeleteMessage = null;
    try {
      await firstValueFrom(
        this.visaApplicationService.deleteVisaDocument(
          this.selectedVisaApplication.visaApplicationCustomerId
        )
      );

      this.selectedVisaApplication.visaDocumentUrl = '';
      this.visaDeleteMessage = 'Vize dökümanı başarıyla silindi.';
      this.visaDeleteMessageStatus = 'success';
    } catch (error: any) {
      this.visaDeleteMessage = 'Vize dökümanı silinirken bir hata oluştu.';
      this.visaDeleteMessageStatus = 'error';
    } finally {
      setTimeout(() => {
        this.visaDeleteMessage = null;
      }, 3000);
    }
  }
  onShowPopup(): void {
    this.documentPopupVisible = true;
    this.loadVisaHtml();
  }

  loadVisaHtml(): void {
    const url =
      environment.imageUrl +
      this.selectedVisaApplication.visaDocumentUrl.replace(/\\/g, '/');

    this.loadingService.show();

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        this.visaHtmlContent = `
        <style>
          * { max-width: 100% !important; width: 100% !important; box-sizing: border-box; }
        </style>
        ${html}`;
        this.loadingService.hide();
      })
      .catch((err) => {
        console.error('HTML yüklenemedi:', err);
        this.visaHtmlContent =
          '<p class="text-danger">Vize dökümanı yüklenemedi.</p>';
        this.loadingService.hide();
      });
  }

  openVisaDocInNewTab(): void {
    if (!this.selectedVisaApplication?.visaDocumentUrl) return;

    const fullPath =
      environment.imageUrl +
      this.selectedVisaApplication.visaDocumentUrl.replace(/\\/g, '/');
    window.open(fullPath, '_blank');
  }

  async sendVisaEmailNotification() {
    this.mailWarningMessage = null;

    const dto = {
      customerId: this.selectedVisaApplication.visaApplicationCustomerId,
      visaApplicationId: this.selectedVisaApplication.id,
    };

    try {
      this.loadingService.show();

      await firstValueFrom(
        this.visaApplicationService.sendVisaNotificationEmail(dto)
      );

      this.mailWarningMessage = 'E-Posta bildirimi başarıyla gönderildi.';
      this.mailStatus = 'success';
    } catch {
      this.mailWarningMessage = 'E-Posta bildirimi gönderilemedi.';
      this.mailStatus = 'error';
    } finally {
      this.loadingService.hide();

      setTimeout(() => {
        this.mailWarningMessage = null;
      }, 3000);
    }
  }
  async sendVisaSmsNotification(selectedVisaApplication: any) {
    const number = selectedVisaApplication.customerPhoneNumber;
    const fullName = `${selectedVisaApplication.customerFirstName} ${selectedVisaApplication.customerLastName}`;
    const visaNumber = selectedVisaApplication.visaApplicationId;
    const apiUrl = `${environment.apiUrl}/SendSms?gsmNumber=${number}&fullName=${fullName}&visaNumber=${visaNumber}`;
    this._http.post(apiUrl, {}).subscribe({
      next: (response) => {
        this.notificationService.show('SMS bildirimi başarıyla gönderildi.');
      },
      error: (error) => {
        this.notificationService.showError('SMS bildirimi gönderilemedi.');
      },
    });
  }
  copyText(text: string, fieldName: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed'; // Mobilde düzgün çalışması için
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    this.copiedField = fieldName;

    setTimeout(() => {
      this.copiedField = null;
    }, 2000);
  }

  copyTextFromDate(date: Date, fieldName: string): void {
    const formatted = formatDate(date, 'dd.MM.yyyy', 'en-US');
    this.copyText(formatted, fieldName);
  }

  async sendInvoice() {
    if (!this.selectedVisaApplication?.id) {
      this.notificationService.showError('Vize başvuru bilgisi bulunamadı');
      return;
    }

    this.loadingService.show();

    try {
      await firstValueFrom(
        this.invoiceService.sendInvoice(this.selectedVisaApplication.id)
      );
      
      this.notificationService.show('Fatura başarıyla kesildi', { type: 'success' });
      
      this.selectedVisaApplication.isInvoiceSended = true;
      
   
      this.invoiceUpdated.emit();
      
    } catch (error: any) {
      const errorMessage = error?.error || 'Fatura kesilirken bir hata oluştu';
      this.notificationService.showError(errorMessage);
    } finally {
      this.loadingService.hide();
    }
  }

  async showInvoicePdf() {
    if (!this.selectedVisaApplication?.id) {
      this.notificationService.showError('Fatura bilgisi bulunamadı');
      return;
    }
    this.loadingService.show();

    try {
      const response = await firstValueFrom(
        this.invoiceService.showInvoicePdf(this.selectedVisaApplication.id)
      );
      
      // Response zaten Blob 
      const blobUrl = window.URL.createObjectURL(response);
      
      window.open(blobUrl, '_blank');
     
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);
      
    } catch (error: any) {
      const errorMessage = error?.error || 'Fatura PDF\'i görüntülenirken bir hata oluştu';
      this.notificationService.showError(errorMessage);
    } finally {
      this.loadingService.hide();
    }
  }

  async sendInvoiceMail() {
      if (!this.selectedVisaApplication?.id) {
        this.notificationService.showError('Fatura bilgisi bulunamadı');
        return;
      }
      this.loadingService.show();
      try {
        await firstValueFrom(
          this.invoiceService.sendInvoiceMail(this.selectedVisaApplication.id)
        );
        this.notificationService.show('Fatura maili başarıyla gönderildi', { type: 'success' });
      } catch (error: any) {
        const errorMessage = error?.error || 'Fatura maili gönderilirken bir hata oluştu';
        this.notificationService.showError(errorMessage);
      } finally {
        this.loadingService.hide();
      }
    }

}

